"use client";
import CategoryCard from "@/components/product-category/category-card";
import { Button } from "@/components/ui/button";
import { handleParse } from "@/lib/handleParse";
import { ProvningarSektion } from "@/types/page";
import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import React from "react";

export default function ProvningarLayout({
  content,
}: {
  content: ProvningarSektion;
}) {
  return (
    <section className="layout">
      <div className="xl:pr-56 pb-10 ">
        {content?.text && handleParse(content.text)}
      </div>
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ">
        {content?.valj8Provningar &&
          content.valj8Provningar.nodes.map((provning, index: number) => (
            <li key={provning.id} className="">
              <CategoryCard product={provning} index={index} />
            </li>
          ))}
      </ul>

      <div className="flex justify-center pt-8">
        <Button
          effect="expandIcon"
          icon={ArrowRightIcon}
          iconPlacement="right"
          asChild
        >
          <Link href="/vara-provningar">Se alla provningar</Link>
        </Button>
      </div>
    </section>
  );
}

export function ProvningarSkeleton() {
  return (
    <section className="layout">
      <div className="xl:pr-56 pb-10">
        {/* Text skeleton */}
        <div className="space-y-2">
          <div className="h-6 bg-gray-200 rounded-md animate-pulse w-3/4" />
          <div className="h-4 bg-gray-200 rounded-md animate-pulse w-full" />
          <div className="h-4 bg-gray-200 rounded-md animate-pulse w-5/6" />
          <div className="h-4 bg-gray-200 rounded-md animate-pulse w-4/5" />
        </div>
      </div>

      {/* Cards skeleton */}
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, index) => (
          <li key={index} className="animate-pulse">
            <div className="bg-gray-200 rounded-lg overflow-hidden">
              {/* Image placeholder */}
              <div className="h-48 bg-gray-300" />
              {/* Content placeholder */}
              <div className="p-4 space-y-3">
                <div className="h-5 bg-gray-300 rounded w-3/4" />
                <div className="h-4 bg-gray-300 rounded w-full" />
                <div className="h-4 bg-gray-300 rounded w-2/3" />
                <div className="h-8 bg-gray-300 rounded w-1/2 mt-4" />
              </div>
            </div>
          </li>
        ))}
      </ul>

      {/* Button skeleton */}
      <div className="flex justify-center pt-8">
        <div className="h-10 w-40 bg-gray-300 rounded-md animate-pulse" />
      </div>
    </section>
  );
}
